// ── API Endpoints (SANS préfixe /api — le client axios l'ajoute) ──

export const API_ENDPOINTS = {
  DASHBOARD: "/creation/dashboard",

  ARTICLES: {
    LIST: "/articles",
    DETAIL: (id: number | string) => `/articles/${id}` as const,
    METRICS: "/creation/articles/metrics",
  },

  ATELIERS: {
    LIST: "/ateliers",
    DETAIL: (id: number | string) => `/ateliers/${id}` as const,
  },

  // ⚠️ "postes" (ldf) est une ressource DISTINCTE de POSTE_TRAVAILS — ne pas fusionner.
  POSTES: "/postes",
  POSTE_TRAVAILS: {
    LIST: "/poste_travails",
    DETAIL: (id: number | string) => `/poste_travails/${id}` as const,
    METRICS: "/creation/postes/metrics",
  },

  PRESTATIONS: {
    LIST: "/prestations",
    DETAIL: (id: number | string) => `/prestations/${id}` as const,
  },

  FAMILLE_ARTICLES: {
    LIST: "/famille_articles",
    DETAIL: (id: number | string) => `/famille_articles/${id}` as const,
  },

  UNIVERS_COMMERCIAUX: {
    LIST: "/univers_commercials",
    DETAIL: (id: number | string) => `/univers_commercials/${id}` as const,
  },

  DOSSIER_TECHNIQUES: {
    LIST: "/dossier_techniques",
    DETAIL: (id: number | string) => `/dossier_techniques/${id}` as const,
    VALIDATE: (id: number | string) => `/creation/dossier_techniques/${id}/validate` as const,
  },

  LDFS: {
    LIST: "/ldfs",
    DETAIL: (id: number | string) => `/ldfs/${id}` as const,
  },

  DOCUMENTS: {
    LIST: "/documents",
    DETAIL: (docId: number | string) => `/documents/${docId}` as const,
    PREVIEW: (docId: number | string) => `/documents/${docId}/preview` as const,
    UPLOAD: "/documents/upload",
  },

  REFERENCE: {
    MARQUES: "/marques",
    ARTICLE_COLLECTIONS: "/article_collections",
    UNITE_MESURES: "/unite_mesures",
    SOUS_FAMILLES: "/sous_familles",
    DEPOTS: "/depots",
  },
} as const;

// ──────────────────────────── Routes ────────────────────────────

export const ROUTES = {
  CREATION: {
    INDEX: "/creation",
    ARTICLES: {
      LIST: "/creation/articles",
      CREATE: "/creation/articles/create",
      VIEW: "/creation/articles/$id/view",
      EDIT: "/creation/articles/$id/edit",
    },
    ATELIERS: {
      LIST: "/creation/ateliers",
      CREATE: "/creation/ateliers/create",
      VIEW: "/creation/ateliers/$id/view",
      EDIT: "/creation/ateliers/$id/edit",
    },
    DOSSIER_TECHNIQUES: {
      LIST: "/creation/dossier-techniques",
      CREATE: "/creation/dossier-techniques/create",
      VIEW: "/creation/dossier-techniques/$id/view",
      EDIT: "/creation/dossier-techniques/$id/edit",
    },
    FAMILLE_ARTICLES: {
      LIST: "/creation/familleArticles",
      CREATE: "/creation/familleArticles/create",
      VIEW: "/creation/familleArticles/$id/view",
      EDIT: "/creation/familleArticles/$id/edit",
    },
    LDF: {
      LIST: "/creation/ldf",
      CREATE: "/creation/ldf/create",
      VIEW: "/creation/ldf/$id/view",
      EDIT: "/creation/ldf/$id/edit",
    },
    POSTES: {
      LIST: "/creation/postes",
      CREATE: "/creation/postes/create",
      VIEW: "/creation/postes/$id/view",
      EDIT: "/creation/postes/$id/edit",
    },
    PRESTATIONS: {
      LIST: "/creation/prestations",
      CREATE: "/creation/prestations/create",
      VIEW: "/creation/prestations/$id/view",
      EDIT: "/creation/prestations/$id/edit",
    },
    UNIVERS_COMMERCIAUX: {
      LIST: "/creation/univers-commerciaux",
      CREATE: "/creation/univers-commerciaux/create",
      VIEW: "/creation/univers-commerciaux/$id/view",
      EDIT: "/creation/univers-commerciaux/$id/edit",
    },
  },
} as const;
